import { render, staticRenderFns } from "./TDestinationsSmall.vue?vue&type=template&id=35425792&scoped=true&"
import script from "./TDestinationsSmall.vue?vue&type=script&lang=js&"
export * from "./TDestinationsSmall.vue?vue&type=script&lang=js&"
import style0 from "./TDestinationsSmall.vue?vue&type=style&index=0&id=35425792&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35425792",
  null
  
)

/* custom blocks */
import block0 from "./TDestinationsSmall.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports